import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemAvatar from '@material-ui/core/ListItemAvatar'
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction'
import ListItemText from '@material-ui/core/ListItemText'
import Avatar from '@material-ui/core/Avatar'
import IconButton from '@material-ui/core/IconButton'
import Typography from '@material-ui/core/Typography'
import FolderIcon from '@material-ui/icons/Folder'
import DeleteIcon from '@material-ui/icons/Delete'
import Paper from '@material-ui/core/Paper'
import Fab from '@material-ui/core/Fab'
import AddIcon from '@material-ui/icons/Add'
import MenuIcon from '@material-ui/icons/Menu'
import AccountCircle from '@material-ui/icons/AccountCircle'
import MenuItem from '@material-ui/core/MenuItem'
import Menu from '@material-ui/core/Menu'
import Modal from '@material-ui/core/Modal'
import { format } from 'date-fns'
import FormControl from '@material-ui/core/FormControl'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import Button from '@material-ui/core/Button'
import { Link } from 'react-router-dom'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    maxWidth: 752,
    width: 'auto',
    display: 'block', // Fix IE 11 issue.
    marginLeft: theme.spacing.unit * 1,
    marginRight: theme.spacing.unit * 1,
    [theme.breakpoints.up(800 + theme.spacing.unit * 3 * 2)]: {
      width: 800,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
    backgroundColor: '#ffffff',
  },
  title: {
    margin: `${theme.spacing.unit * 4}px 0 ${theme.spacing.unit * 2}px`,
  },
  paper: {
    marginTop: theme.spacing.unit * 12,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
  },
  fab: {
    position: 'fixed',
    bottom: theme.spacing.unit * 5,
    right: theme.spacing.unit * 5,
  },
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
  },
  modal: {
    position: 'absolute',
    width: theme.spacing.unit * 50,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing.unit * 4,
    outline: 'none',
    top: `50%`,
    left: `50%`,
    transform: `translate(-50%, -50%)`,
  },
  submit: {
    marginTop: 50,
  },
})

const generateListItem = (groups, deleteGroup) => {
  return groups.map((e) => (
    <Link
      key={e.uniqid}
      style={{ textDecoration: 'none' }}
      to={`/garmin/${e.uniqid}/dashboard/patients`}
    >
      <ListItem button divider={true}>
        <ListItemAvatar>
          <Avatar>
            <FolderIcon />
          </Avatar>
        </ListItemAvatar>
        <ListItemText
          primary={`${e.name}`}
          secondary={`${e.description} - ${format(new Date(e.created_at), 'MMM, dd yy')}`}
        />
        <ListItemSecondaryAction onClick={(event) => deleteGroup(event, e.name, e.uniqid)}>
          <IconButton aria-label="Delete">
            <DeleteIcon />
          </IconButton>
        </ListItemSecondaryAction>
      </ListItem>
    </Link>
  ))
}

class InteractiveList extends Component {
  state = {
    anchorEl: null,
    modalOpen: false,
    deleteDialog: false,
    deleteGroupName: '',
    deleteGroupID: '',
    groups: [],
  }

  async fetchGroups() {
    try {
      const result = await fetch(`/garmin/api/groups`, {
        mode: 'cors',
        method: 'GET',
      })

      const data = await result.json()

      if (data.success) {
        this.setState({ groups: data.data })
      }
    } catch (err) {
      console.log(err)
      // this.props.history.push("/login");
    }
  }

  componentDidMount() {
    this.fetchGroups()
  }

  handleDeleteClose = () => {
    this.setState({ deleteDialog: false })
  }

  handleMenu = (event) => {
    this.setState({ anchorEl: event.currentTarget })
  }

  handleClose = () => {
    this.setState({ anchorEl: null })
  }

  handleModalOpen = () => {
    this.setState({ modalOpen: true })
  }

  handleModalClose = () => {
    this.setState({ modalOpen: false })
  }

  deleteGroup = (e, name, uniqid) => {
    e.preventDefault()
    this.setState({
      deleteDialog: true,
      deleteGroupName: name,
      deleteGroupID: uniqid,
    })
  }

  render() {
    const { classes } = this.props

    const { anchorEl } = this.state
    const open = Boolean(anchorEl)

    return (
      <div>
        <AppBar position="fixed">
          <Toolbar>
            <Typography variant="h6" color="inherit" className={classes.grow}>
              GOLAB Gerontech Platform
            </Typography>
            <div>
              <IconButton
                aria-owns={open ? 'menu-appbar' : undefined}
                aria-haspopup="true"
                onClick={this.handleMenu}
                color="inherit"
              >
                <AccountCircle />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={open}
                onClose={this.handleClose}
              >
                <Link key={'fitbit'} style={{ textDecoration: 'none' }} to={`/groups`}>
                  <MenuItem>Fitbit</MenuItem>
                </Link>
              </Menu>
            </div>
          </Toolbar>
        </AppBar>
        <div className={classes.root}>
          <Paper className={classes.paper}>
            <Typography variant="h6" className={classes.title}>
              Garmin 群組
            </Typography>
            <List style={{ width: 700 }}>
              {generateListItem(this.state.groups, this.deleteGroup)}
            </List>
          </Paper>
          <Fab className={classes.fab} color={'primary'} onClick={this.handleModalOpen}>
            <AddIcon />
          </Fab>
        </div>
        <Modal
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          open={this.state.modalOpen}
          onClose={this.handleModalClose}
        >
          <div className={classes.modal}>
            <Typography variant="h6" id="modal-title">
              新增群組
            </Typography>
            <form method="post" action="/garmin/api/createGroup" className={classes.form}>
              <FormControl margin="normal" required fullWidth>
                <InputLabel htmlFor="name">群組名稱</InputLabel>
                <Input id="name" name="name" autoFocus />
              </FormControl>
              <FormControl margin="normal" required fullWidth>
                <InputLabel htmlFor="description">描述</InputLabel>
                <Input name="description" id="description" />
              </FormControl>
              <Button onClick={this.handleModalClose} className={classes.submit}>
                取消
              </Button>
              <Button type="submit" className={classes.submit}>
                建立
              </Button>
            </form>
          </div>
        </Modal>
        <Dialog
          open={this.state.deleteDialog}
          onClose={this.handleDeleteClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <form method="post" action="/garmin/api/deleteGroup">
            <Input type="hidden" id="uniqid" name="uniqid" value={this.state.deleteGroupID} />
            <DialogTitle id="alert-dialog-title">
              確定要刪除群組【 {this.state.deleteGroupName}】
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                此動作為不可逆的操作！
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleDeleteClose} color="primary">
                取消
              </Button>
              <Button onClick={this.handleDeleteClose} color="primary" type="submit" autoFocus>
                確認
              </Button>
            </DialogActions>
          </form>
        </Dialog>
      </div>
    )
  }
}

InteractiveList.propTypes = {
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(InteractiveList)
